import { IPayemntsList } from '../types/PayemntsList';

export const getPayemntList = (item?: IPayemntsList) => ({
  id: item?.id ?? 0,
  text: item?.text ?? '',
});

export const paymentListAdapter = (data?: IPayemntsList[]) =>
  data?.map(item => getPayemntList(item)) ?? [];
